import React, { useState } from 'react';

interface ResultDisplayProps {
  jsonResult: string | null;
  markdownResult: string | null;
}

export const ResultDisplay: React.FC<ResultDisplayProps> = ({ jsonResult, markdownResult }) => {
  const [copied, setCopied] = useState(false);
  
  const result = jsonResult || markdownResult;
  
  const handleCopy = () => {
    if (result) {
      navigator.clipboard.writeText(result);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    }
  };
  
  const handleDownload = () => {
    if (!result) return;
    
    const isJson = !!jsonResult;
    const blob = new Blob([result], { type: isJson ? 'application/json' : 'text/markdown' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = isJson ? 'tcmf-messages.json' : 'tcmf-messages.md';
    document.body.appendChild(link);
    link.click();
    URL.revokeObjectURL(url);
    document.body.removeChild(link);
  };
  
  if (!result) return null;
  
  return (
    <div className="bg-white rounded-lg border border-gray-200 overflow-hidden">
      <div className="flex justify-between items-center p-4 bg-gray-50 border-b border-gray-200">
        <h2 className="text-lg font-medium">
          {jsonResult ? 'JSON Output' : 'Markdown Output'}
        </h2>
        <div className="space-x-2">
          <button
            onClick={handleCopy}
            className="bg-gray-200 hover:bg-gray-300 py-1 px-3 rounded text-sm"
          >
            {copied ? 'Copied!' : 'Copy'}
          </button>
          <button
            onClick={handleDownload}
            className="bg-blue-500 hover:bg-blue-600 text-white py-1 px-3 rounded text-sm"
          >
            Download
          </button>
        </div>
      </div>
      
      <div className="p-4 max-h-96 overflow-auto">
        <pre className="text-sm whitespace-pre-wrap">{result}</pre>
      </div>
    </div>
  );
};

